var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulkManage = function SvgBulkManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 28,
    y1: 97.9,
    x2: 193.1,
    y2: -7.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -3.9,
    y1: 54.3,
    x2: 28.1,
    y2: 33.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -3.6,
    y1: 110.5,
    x2: 28.1,
    y2: 90.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3.6,
    y1: 166.7,
    x2: 28.1,
    y2: 146.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 27.4,
    y1: 158.6,
    x2: 205.9,
    y2: 44.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 30,
    y1: 195.1,
    x2: 148.5,
    y2: 119.2,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.1,56.2h125c6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5H50.1c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.8,34.9C1.4,37.3,0,40.4,0,43.7c0,.8,0,1.6,0,2.4.1.8.4,1.6.7,2.4.3.7.7,1.5,1.2,2.1.4.7,1,1.4,1.6,1.9.6.6,1.2,1.1,1.9,1.5.7.5,1.4.9,2.1,1.2.8.4,1.7.7,2.6.9.8,0,1.6,0,2.4,0,3.3,0,6.5-1.3,8.8-3.6.6-.6,1.1-1.2,1.6-1.9.5-.7.9-1.4,1.2-2.1.4-.8.7-1.6.9-2.4,0-.8,0-1.6,0-2.4,0-3.3-1.3-6.5-3.7-8.8-4.9-4.8-12.7-4.8-17.6,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M22.9,93c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.7-4.8-17.6,0-2.3,2.3-3.7,5.5-3.7,8.8,0,1.6.3,3.3.9,4.8.3.7.7,1.4,1.1,2.1.5.7,1,1.3,1.6,1.9.6.6,1.2,1.1,1.9,1.6.7.5,1.4.9,2.1,1.2.8.3,1.6.6,2.4.7.8.2,1.6.3,2.4.2.8,0,1.6,0,2.4,0,.8-.1,1.6-.4,2.3-.7.8-.3,1.5-.7,2.2-1.2.7-.4,1.3-1,1.9-1.6.6-.6,1.1-1.2,1.6-1.9.5-.7.9-1.4,1.2-2.1.4-.8.7-1.7.9-2.6,0-.8,0-1.6,0-2.4,0-.8,0-1.6,0-2.4-.2-.8-.5-1.6-.9-2.3-.3-.8-.7-1.5-1.2-2.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.9,149.3c-.4-.7-1-1.3-1.6-1.9-4.9-4.8-12.7-4.8-17.6,0-.6.6-1.1,1.2-1.6,1.9-.5.7-.9,1.4-1.2,2.1-.3.8-.6,1.6-.7,2.4-.2.8-.3,1.6-.3,2.4,0,3.3,1.3,6.5,3.7,8.8.6.6,1.2,1.1,1.9,1.6.7.5,1.4.9,2.1,1.2.8.3,1.6.6,2.4.7.8.2,1.6.3,2.4.2.8,0,1.6,0,2.4,0,.8-.1,1.6-.4,2.3-.7.8-.3,1.5-.7,2.2-1.2.7-.4,1.3-1,1.9-1.6.6-.6,1.1-1.2,1.6-1.9.5-.7.9-1.4,1.2-2.1.4-.8.7-1.7.9-2.6,0-.8,0-1.6,0-2.4,0-.8,0-1.6,0-2.4-.2-.8-.5-1.6-.9-2.4-.3-.7-.7-1.5-1.2-2.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M187.5,87.5H50.1c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5h137.5c6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.3,143.7H50.1c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5h81.2c6.9,0,12.5-5.6,12.5-12.5s-5.6-12.5-12.5-12.5Z"
  })));
};
export default SvgBulkManage;